import api from './api';

const resolveBridge = (res) => res?.bridge ?? res;

const bridgeService = {
  getAll: (params) => api.get('/bridges', params),
  getAllForMap: () => api.get('/bridges', { forMap: true }),
  getOne: (id)        => api.get(`/bridges/${id}`),
  /** Full bridge with populated owners, admins, managers, engineers */
  fetchDetail: async (id) => resolveBridge(await api.get(`/bridges/${id}`)),
  // Staff save sends account emails before responding; allow that to finish.
  create: (data)      => api.post('/bridges', data, { timeout: 120000 }),
  update: (id, data)  => api.put(`/bridges/${id}`, data, { timeout: 120000 }),
  delete: (id)        => api.delete(`/bridges/${id}`),

  // Data loggers
  addDataLogger:    (bridgeId, data)              => api.post(`/bridges/${bridgeId}/data-loggers`, data),
  updateDataLogger: (bridgeId, dataLoggerId, data) => api.put(`/bridges/${bridgeId}/data-loggers/${dataLoggerId}`, data),
  deleteDataLogger: (bridgeId, dataLoggerId)      => api.delete(`/bridges/${bridgeId}/data-loggers/${dataLoggerId}`),

  // Sensors
  addSensor:    (bridgeId, data)          => api.post(`/bridges/${bridgeId}/sensors`, data),
  updateSensor: (bridgeId, sensorId, data)=> api.put(`/bridges/${bridgeId}/sensors/${sensorId}`, data),
  deleteSensor: (bridgeId, sensorId)      => api.delete(`/bridges/${bridgeId}/sensors/${sensorId}`),

  // Spec limits
  updateSpecLimits: (bridgeId, sensorId, data) =>
    api.put(`/bridges/${bridgeId}/sensors/${sensorId}/spec-limits`, data),
  /** Upload Excel (.xlsx/.xls) with X/Y/Z threshold sheets; backend parses & saves all axes. */
  uploadSpecLimitsExcel: (bridgeId, sensorId, formData) =>
    api.upload(`/bridges/${bridgeId}/sensors/${sensorId}/spec-limits/upload`, formData),
  /**
   * Bulk upload Excel thresholds for multiple sensors on a bridge.
   * FormData: file + sensorIds[] (same threshold values applied to each sensorId).
   */
  uploadSpecLimitsExcelBulk: (bridgeId, formData) =>
    api.upload(`/bridges/${bridgeId}/sensors/spec-limits/upload-bulk`, formData),
  /** Save per-sensor battery voltage limit used for battery health % on Sensor Data page. */
  updateBatteryVoltageLimit: (bridgeId, sensorId, data) =>
    api.put(`/bridges/${bridgeId}/sensors/${sensorId}/battery-voltage-limit`, data),
  /** Save per-data-logger battery voltage limit (SID source on Sensor Data page). */
  updateDataLoggerBatteryVoltageLimit: (bridgeId, dataLoggerId, data) =>
    api.put(`/bridges/${bridgeId}/data-loggers/${dataLoggerId}/battery-voltage-limit`, data),
  getLogbook: (bridgeId, sensorId) =>
    api.get(`/bridges/${bridgeId}/sensors/${sensorId}/logbook`),
};

export default bridgeService;
